<template>
    <!-- 联系我们 -->
    <div class="concat">
        <div class="c_banner" :style="{backgroundImage: 'url(' + banner + ')'}">
            <div class="text_p_fixed">
                <div class="text_box">
                    <div class="opcity"></div>
                    <div class="opcity1">
                        <div class="text1">{{title.top_name}}</div>
                        <div class="text2">{{title.top_title}}</div>
                        <div class="text3">{{title.next_title}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="case_box">
            <div class="flex-center mt70">
                <img src="../../static/img/contact/contact.png" alt="">
            </div>
            <!-- <div class="concat_logo">
              <div class="left">
                  <div class="bty"></div>
                  <div class="btc"></div>
              </div>
              <div class="center">
                  <div class="c_text">联系方式</div>
                  <div class="c_text1">Contact information</div>
              </div>
              <div class="left">
                   <div class="btc"></div>
                  <div class="bty"></div>
              </div>
          </div> -->
            <ul class="p_email_tel">
                <li class="p_email_tel_li" v-for="(item,index) in addresslist" :key="index">
                    <div class="img_bg">
                        <img :src="item.icon" alt="">
                    </div>
                    <div class="type">{{item.title}}</div>
                    <div class="address">{{item.text}}</div>
                </li>
            </ul>
            <div class="map_box">
                <div class="mapcenter">
                    <div class="m_title">地图导航</div>
                    <div id="map" class="map"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getAboutUsTitle,getAboutUs,getNavList
    } from '../../api/apis.js'
    export default {
        name: 'Talent',
        data() {
            return {
                title: {},
                banner:'',
                url: require('../../assets/gimg22.png'),
                showlistb: true,
                caseactive: 0,
                casenav: [{
                        'id': 0,
                        'title': '人才结构',
                        'showtable': true
                    },
                    {
                        'id': 1,
                        'title': '员工培养',
                        'showtable': false
                    },
                    {
                        'id': 2,
                        'title': '招聘职位',
                        'showtable': false
                    }
                ],
                addresslist: [{
                        'id': 0,
                        'title': '联系地址',
                        'text': '',
                        'icon': require('../../assets/c6.png')
                    },
                    {
                        'id': 1,
                        'title': '邮箱',
                        'text': '',
                        'icon': require('../../assets/c7.png')
                    },
                    {
                        'id': 2,
                        'title': '电话',
                        'text': '',
                        'icon': require('../../assets/c8.png')
                    }
                ]
            }
        },
        components: {

        },
        mounted() {
            getNavList().then(res => {
                let navBanner = [];
                let cate = [];
                let navList = [
                    { id: 0, title: "首页", path: "/" },
                    { id: 0, title: "业务范围", path: "/busines" },
                    { id: 0, title: "公司简介", path: "/brief" },
                    { id: 0, title: "工程案例", path: "/casecenter" },
                    { id: 0, title: "新闻中心", path: "/newscenter" },
                    { id: 0, title: "人才招聘", path: "/talent" },
                    { id: 0, title: "联系我们", path: "/concat" }
                ];
                res.forEach((item, index) => {
                    navList[index].id = item.id;
                    navList[index].title = item.cate_name;
                    navBanner[index] = item.cate_img;
                    cate.push(item.next_cate);
                });
                // console.log(cate,'dddddd')
                this.banner = navBanner[6]
                this.casenav = cate[3];
                // this.getList();

            })
            this.$nextTick(() => {
                this.initBmap(104.1218777225, 30.6256664374, "成都");
            });
            this.getTitle();
            this.getAddress();
            // this.banner = this.$store.state.navBanner[6];

        },
        methods: {
            getTitle() {

                getAboutUsTitle().then(res => {
                    this.title = res;
                })
            },
            getAddress(){
                getAboutUs().then(res => {
                    this.addresslist[0].text = res.address;
                    this.addresslist[1].text = res.email;
                    this.addresslist[2].text = res.tel;
                   
                })
            },
            //改变路由按钮颜色
            casenav_func(index) {
                this.caseactive = index;
                this.casenav = [{
                        'id': 0,
                        'title': '人才结构',
                        'showtable': false
                    },
                    {
                        'id': 1,
                        'title': '员工培养',
                        'showtable': false
                    },
                    {
                        'id': 2,
                        'title': '招聘职位',
                        'showtable': false
                    }
                ];
                this.casenav[index].showtable = true;
            },
            //显示案例详情
            navtocaselist() {
                this.showlistb = !this.showlistb;
                switch (this.caseactive) {
                    case 0:
                        this.$refs.caselist.getindex('返回公司新闻', this.caseactive);
                        break;
                    case 1:
                        this.$refs.caselist.getindex('返回行业新闻', this.caseactive);
                        break;
                    default:
                        break;
                }
            },
            //接受子组件参数，返回上一级；
            gotohistory(data) {
                if (data) {
                    this.showlistb = true;
                }
            },
            //   初始化百度地图
            initBmap(zb1, zb2, a_name) {
                var map = new BMap.Map("map"); // 创建Map实例
                // 初始化地图,设置中心点坐标和地图级别
                map.centerAndZoom(new BMap.Point(121.551257, 38.890002), 16);
                //添加地图类型控件
                map.addControl(
                    new BMap.MapTypeControl({
                        mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP]
                    })
                );
                map.setCurrentCity(a_name); // 设置地图显示的城市 此项是必须设置的
                map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
                var point = new BMap.Point(zb1, zb2);
                map.centerAndZoom(point, 10);
                var myIcon = new BMap.Icon(this.url, new BMap.Size(40, 45));
                // 创建标注
                var marker = new BMap.Marker(point, {
                    icon: myIcon
                });

                var content = "<div  style='width:436px;'>";
                content = content +
                    "<div style='width:436px;font-size:24px;line-height:22px;color:rgba(51,51,51,1);text-align: center;'>四川华顺源建设工程有限公司</div>";
                content = content +
                    "<div style='margin-top:15px;width:550px;height:47px;font-size:12px;font-family:Microsoft YaHei;font-weight:400;line-height:28px;color:rgba(153,153,153,1);'>注册地址：四川省成都市武侯区星狮路711号1栋2单元11层1104号<div>";
                content = content +
                    "<div style='width:550px;height:47px;font-size:12px;font-family:Microsoft YaHei;font-weight:400;line-height:28px;color:rgba(153,153,153,1);'>办公地址：四川省成都市武侯区星狮路711号1栋2单元11层1104号<div>";
                content += "</div>";

                marker.addEventListener("click", function () {
                    this.openInfoWindow(new BMap.InfoWindow(content));
                });
                setTimeout(() => {
                    marker.openInfoWindow(new BMap.InfoWindow(content));
                }, 100);

                map.addOverlay(marker);
            },
        },
    }
    // 注册地址：四川省成都市武侯区星狮路711号1栋2单元11层1104号 
    // 办公地址：四川省成都市武侯区星狮路711号1栋2单元11层1104号
</script>
<style scoped lang="scss">
    .mt70 {
        margin-top: 70px;
    }

    .concat {
        // border:1px solid red;
        background: #ffffff;
        width: 100%;

        .c_banner {
            border-top: 1px solid #ffffff;
            height: 500px;
            width: 100%;
            min-width: 1200px;
            margin: 0 auto;

            /* background: url('../../assets/c5.png') no-repeat; */
            background-size: 100% 500px;

            .text_p_fixed {
                //  border:1px solid red;
                width: 1200px;
                height: 500px;
                margin: 0 auto;

                .text_box {
                    // border:1px solid red;
                    width: 600px;
                    height: 200px;
                    margin-left: 180px;
                    margin-top: 104px;

                    position: relative;

                    .opcity {
                        //  border:1px solid red;
                        width: 600px;
                        height: 200px;
                        position: absolute;
                        background: rgba(0, 0, 0, 1);
                        opacity: 0.4;
                        z-index: 0;
                    }

                    .opcity1 {
                        //  border:1px solid red;
                        width: 600px;
                        height: 200px;
                        position: absolute;
                        z-index: 1;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                        align-items: center;
                    }

                    .text1 {
                        // border:1px solid red;
                        // width:212px;
                        font-size: 36px;
                        font-family: 迷你简综艺;
                        font-weight: 400;
                        color: rgba(255, 255, 255, 1);
                        opacity: 1;
                        line-height: 48px;
                    }

                    .text2 {
                        // border:1px solid red;
                        width: 473px;
                        height: 50px;
                        background: rgba(51, 51, 51, 1);
                        opacity: 1;

                        font-size: 20px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 50px;
                        color: rgba(255, 255, 255, 1);
                        opacity: 1;
                        text-align: center;
                    }

                    .text3 {
                        // border:1px solid red;
                        width: 440px;
                        height: 41px;
                        font-size: 16px;
                        font-family: RTWS YueRoundedGothic Demo;
                        font-weight: normal;
                        line-height: 24px;
                        color: #B7AFB4;
                        text-align: center;
                        opacity: 1;
                    }
                }
            }
        }

        .case_box {
            // border:1px solid red;
            width: 1200px;
            // height: 1200px;
            margin: 0 auto;

            .concat_logo {
                //   border:1px solid red;
                width: 800px;
                height: 100px;
                margin: 0 auto;
                display: flex;
                justify-content: center;
                align-items: center;

                .left {
                    //   border:1px solid red;
                    width: 110px;
                    height: 17px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;

                    .bty {
                        width: 98px;
                        height: 3px;
                        background: rgba(211, 211, 211, 1);
                        opacity: 1;
                    }

                    .btc {
                        width: 16px;
                        height: 16px;
                        border: 1px solid rgba(211, 211, 211, 1);
                        border-radius: 50%;
                        opacity: 1;
                    }
                }

                .center {
                    //   border: 1px solid red;
                    width: 300px;
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    flex-direction: column;

                    .c_text {
                        //    border: 1px solid red;
                        width: 138px;
                        height: 42px;
                        font-size: 32px;
                        font-family: MicrosoftYaHei;
                        line-height: 42px;
                        color: rgba(51, 51, 51, 1);
                        opacity: 1;
                    }

                    .c_text1 {
                        //    border: 1px solid red;
                        height: 35px;
                        font-size: 26px;
                        font-family: MicrosoftYaHei;
                        line-height: 35px;
                        color: rgba(153, 153, 153, 1);
                        opacity: 1;
                    }
                }

            }

            .p_email_tel {
                //   border:1px solid red;
                width: 100%;
                display: flex;
                justify-content: center;
                margin-top: 50px;

                .p_email_tel_li {
                    //   border:1px solid red;
                    width: 250px;
                    height: 190px;
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    flex-direction: column;
                    margin-left: 20px;

                    .img_bg {
                        width: 104px;
                        height: 104px;
                        background: rgba(219, 235, 252, 1);
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        img {
                            width: 38px;
                            height: 40px;
                        }
                    }

                    .type {
                        //   border:1px solid red;
                        width: 100px;
                        height: 31px;
                        font-size: 24px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 31px;
                        color: rgba(51, 51, 51, 1);
                        text-align: center;
                    }

                    .address {
                        width: 218px;
                        height: 41px;
                        font-size: 14px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 22px;
                        color: rgba(153, 153, 153, 1);
                        text-align: center;
                    }
                }
            }

            .map_box {
                border-top: 1px solid #CECECE;
                width: 1200px;
                //   height: 600px;
                margin-top: 80px;
                display: flex;
                justify-content: center;
                align-items: center;

                .mapcenter {
                    // border:1px solid red;
                    width: 960px;
                    height: 510px;
                    margin-bottom: 200px;
                    margin-top: 40px;

                    .m_title {
                        width: 74px;
                        height: 24px;
                        font-size: 18px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 24px;
                        color: rgba(51, 51, 51, 1);
                    }

                    .map {
                        width: 100%;
                        height: 470px;
                        margin-top: 15px;
                    }
                }
            }
        }
    }
</style>